import type { FaireProductEntity } from "../../entity_types/product";

export const manhattan_snack_1: FaireProductEntity = {
  token: "manhattan-snack-1",
  type: "product",
  name: "Gourmet Snack Mix",
  brandName: "Manhattan Snack Co.",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/88286f78cad0921e5e4940ca2f4cfc752fa0346cb502a79c1f621d15dec945eb.webp",
  priceDollars: 11,
  msrpDollars: 18,
  freeShipping: false,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
